import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  GenerateTokenBody,
  GenerateTokenResponse
} from '@/app/common/api/types/socketApiTypes';

const socketApi = createApi({
  reducerPath: 'socketApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    generateToken: build.mutation<GenerateTokenResponse, GenerateTokenBody>({
      query: body => ({
        url: `/go_handler/v2/socket/auth/jwt`,
        method: 'POST',
        body
      })
    })
  })
});

export const { useGenerateTokenMutation } = socketApi;

export default socketApi;
